import { DataPackValue } from '../../app/models/dataPackValue.model';
import { DataPackCalendar } from '../../app/models/dataPackCalendar.model';
import { DataPackService } from '../../app/models/DataPackService.model';
import { Package } from '../../app/models/package.model';
import { DataPackLine } from '../../app/models/dataPackLine.model';

/**
 * @author Thiago Neri
 * @version $Id: dataPackLine.model.ts 69865 2017-11-14 23:51:01Z edivaldo.m.junior $
 */
export class DataPackLineAcount {

  public lineAcountList:  any = [];
  public  lineServiceUpdateMultiplo: Array<DataPackService> = new Array<DataPackService>();

  public constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/app/models/dataPackLineAcount.model.ts